import { HTMLAttributes } from 'react';
import styled from 'styled-components';

interface SectionProps extends HTMLAttributes<HTMLDivElement> {
  disabled?: boolean;
}

export const Styled = styled.section<SectionProps>`
  ${(props) => props.disabled && `pointer-events: none; opacity: 0.4;`}
  margin-bottom: 40px;
`;
